export class Utils {

  static credits() {
    console.log(`%c
 ______     ______     __  __     __
/\\___  \\   /\\  __ \\   /\\ \\/ /    /\\ \\
\\/_/  /__  \\ \\  __ \\  \\ \\  _"-.  \\ \\ \\
  /\\_____\\  \\ \\_\\ \\_\\  \\ \\_\\ \\_\\  \\ \\_\\
  \\/_____/   \\/_/\\/_/   \\/_/\\/_/   \\/_/

    Creative Digital Agency - zaki.it\n`, "font-family:monospace");
  }

  static getVarNS(namespaceName = 'zaux') {
    return namespaceName;
  }

  static getNS() {
    return window[this.getVarNS()] = window[this.getVarNS()] || {};
  }

  static get isDebug() {
    return Utils.getNS().config.debug === true;
  }

  /*!
   * Sanitize and encode all HTML in a user-submitted string
   * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {String} str  The user-submitted string
   * @return {String} str  The sanitized string
   */
  static sanitize(str) {
    const temp = document.createElement('div');
    temp.textContent = str;
    return temp.innerHTML;
  };

}
